// extracted by mini-css-extract-plugin
export default {"container":"JackpotCountdown_container__yqX1o","tiny":"JackpotCountdown_tiny__7M5tL","dummy":"JackpotCountdown_dummy__pcAVw"};